module.exports = __webpack_public_path__ + "static/hero_home-ec8d430a6e5b331d706fff64f2888f7e.webp";